import React, { useState, useRef, useEffect, useContext } from 'react';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import './HeaderPDF.css';
import { ProjectContext } from "../../context/ProjectProvider";

const HeaderPDF = ({ toolbar }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const { instance } = useMsal();
  const navigate = useNavigate();

  const handleSettingsClick = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handlePaymentClick = () => {
    navigate('/payment');
    setIsMenuOpen(false);
  };

  const handleLogout = async () => {
    try {
      await instance.logoutRedirect({
        postLogoutRedirectUri: process.env.REACT_APP_BASE_URL
      });
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  const { isPdfColumnCollapsed, profile } = useContext(ProjectContext);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="group-header pdf-header">
      <div className={`left-header ${isPdfColumnCollapsed ? "collapsed" : ""}`}>
        {toolbar}
      </div>
      <button
        ref={buttonRef}
        onClick={handleSettingsClick}
        className="pdf-settings-btn"
      >
        <i className="bi bi-person-gear"></i>
      </button>

      {isMenuOpen && (
        <div ref={menuRef} className="group-focus-menu">
          <div className="user-info">
            {profile ? (
              <>
                <div> {profile.given_name}</div>
                <div> {profile.company_name}</div>
                <div> {profile.email}</div>
              </>
            ) : (
              <div>Loading profile...</div>
            )}
          </div>
          <button className="group-btn" onClick={handlePaymentClick}>Payment</button>
          <button className="group-btn logout" onClick={handleLogout}>Logout</button>
        </div>
      )}
    </div>
  );
};

export default HeaderPDF;
